import '@babel/polyfill';
import { hot } from 'react-hot-loader';
import * as React from 'react';
import 'url-search-params-polyfill';

import Root, { IRootProps } from './components/compare-plans';
import {
  ExperienceProvider,
  ExperienceSelector,
  FeatureContextReact,
  FeatureProvider,
} from '@origin-digital/features';
import { Loader } from './components/loader/loader';
import { ErrorMessage } from './components/error-message/error-message';
import { getWindow } from './window/window';
import { mboxes, PLAN_ORDER_MBOX } from './constants/mboxes';
import { MuiThemeProvider } from './MuiThemeProvider';
import { OriginThemeProvider } from '@origin-digital/ods-core';
import styled from 'styled-components';

// This is here to push the footer out of view while the plan is rendering to reduce cumulative layout shift.
const AppContainer = styled.div`
  min-height: 1500px;
`;

const App = () => {
  const props = getWindow().oetal.config['compareplansassets/compareplans'].data;

  if (process.env.NODE_ENV !== 'production') {
    getWindow().cp = {};
  }
  return (
    <AppContainer>
      <FeatureProvider
        loadingPlaceholder={<Loader />}
        failureView={<ErrorMessage />}
        config={{ environment: props.toggleEnv }}
      >
        <MuiThemeProvider>
          <OriginThemeProvider>
            <ExperienceProvider mboxes={mboxes}>
              <ExperienceSelector mbox={PLAN_ORDER_MBOX}>
                {(content) => (
                  <FeatureContextWrapper {...props}>
                    {(p) => <Root {...p} personalisedPlanData={content} />}
                  </FeatureContextWrapper>
                )}
              </ExperienceSelector>
            </ExperienceProvider>
          </OriginThemeProvider>
        </MuiThemeProvider>
      </FeatureProvider>
    </AppContainer>
  );
};

const FeatureContextWrapper = (
  props: IRootProps & { children: (p: IRootProps) => React.ReactNode },
) => {
  const featureContext = React.useContext(FeatureContextReact);
  let updatedProps = Object.assign({}, props);
  updatedProps = Object.assign(updatedProps, {
    featureContext,
  });
  return <>{props.children(updatedProps)}</>;
};

export default hot(module)(App);
